import React, { useState } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Page,
  Sort,
  Filter,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import JobDocketFormModal from './JobDocketFormModal';
import useChipperLoader from './useChipperLoader';
import ChipperInfoDialog from './ChipperInfoDialog';
import ChipperDocsDialog from './components/ChipperDocsDialog';
import { dateTemplate } from '../GenTask/components/SharedFormFields';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
}));

const ChipperLoader = () => {
  const classes = useStyles();

  const {
    spList,
    spListObj,
    isModalOpen,
    setIsModalOpen,
    chipperData,
    handleSave,
    handleRowSelected,
    selectedRecord,
    isViewModalOpen,
    handleViewModalClose,
    docsOpen,
    setDocsOpen,
    handleDocs,
    handleFileChange,
    handleDeleteFiles,
    viewFile,
    files,
    docsLoading,
  } = useChipperLoader();

  const handleAdd = () => {
    setIsModalOpen(true);
  };

  function chipperInfoLinkTemplate(rowData) {
    return (
      <Button
        onClick={() => handleRowSelected(rowData)}
        key={`${rowData.formId}_docket`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%' }}>
        {rowData.formId}
      </Button>
    );
  }

  return (
    <div className="app-wrapper">
      <Box className={classes.header}>
        <Typography variant="h4">Job Dockets</Typography>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleAdd}>
          Add Job Docket
        </Button>
      </Box>

      <GridComponent
        dataSource={chipperData}
        allowPaging={true}
        pageSettings={{ pageSize: 15 }}
        toolbar={['Search']}
        height="600px">
        <ColumnsDirective>
          <ColumnDirective
            field="formId"
            headerText="Chipped ID"
            width="100"
            isPrimaryKey={true}
            template={chipperInfoLinkTemplate}
          />
          <ColumnDirective
            field="dateAndTime"
            headerText="Date and Time"
            width="100"
            type="datetime"
            formatter={dateTemplate}
          />
          <ColumnDirective field="loaderMachineTruck" headerText="Machine" width="150" />
          <ColumnDirective field="customerForOtherWork" headerText="Customer For Other Work" width="150" />
          <ColumnDirective field="totalKM" headerText="Total KM" width="120" textAlign="Right" />
          <ColumnDirective field="totalChargeableTime" headerText="Chargeable Time" width="150" />
        </ColumnsDirective>
        <Inject services={[Page, Sort, Filter, Toolbar]} />
      </GridComponent>

      <JobDocketFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        chipperData={chipperData}
        onSave={handleSave}
        initialData={chipperData}
        spList={spList}
        spListObj={spListObj}
      />

      <ChipperInfoDialog
        open={isViewModalOpen}
        chipperInfoData={selectedRecord}
        handleCloseModal={handleViewModalClose}
        chipperMainData={chipperData}
        handleChipperEdit={() => console.log('www')}
        handleChipperDocs={handleDocs}
      />

      <ChipperDocsDialog
        open={docsOpen}
        onClose={() => setDocsOpen(false)}
        files={files}
        isLoading={docsLoading}
        handleFileChange={handleFileChange}
        handleDeleteFiles={handleDeleteFiles}
        viewFile={viewFile}
        docType="chipper_Docs"
      />
    </div>
  );
};

export default ChipperLoader;
